import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0ee32176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col space-y-10" }
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "3",
    y1: "6",
    x2: "21",
    y2: "6"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "3",
    y1: "12",
    x2: "21",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "3",
    y1: "18",
    x2: "21",
    y2: "18"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  class: "flex flex-col pb-6 space-y-3",
  id: "secondMenu"
}
const _hoisted_6 = { class: "flex flex-row items-center space-x-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/avatar.png",
  alt: "Photo Profi",
  class: "w-10 rounded-full ring-2 ring-accent"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "text-lg text-gray-300"
}
const _hoisted_9 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass([
						{
							'flex flex-col p-2 space-y-2 text-white rounded-md hover:bg-secondary-200 cursor-pointer': true,
						},
					])
}
const _hoisted_10 = { class: "flex-none px-3 py-2 mb-1 font-semibold text-white truncate" }
const _hoisted_11 = { class: "flex flex-col flex-1 min-h-0 space-y-3 overflow-y-auto custumScroll" }

import { inject, ref, computed, watch, onMounted, provide, onBeforeMount } from "vue";
	import { useRouter, useRoute } from "vue-router";
	import { userInfos } from "@/state/api/userState";
	import { authStatus } from "@/state/api/authState";
	import { authLogout } from "@/state/api/authState";
	import useNotyf from "@/composable/useNotyf";
	import { storageConfig } from "@/state/api/userState";
	import i18n from "@/lang/langs";
	import { useSidebar } from "@/composable/useSidebar";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'AppMenu',
  setup(__props) {


	const { collapsed, toggle } = useSidebar();
	const navigations: any = inject("navigations");
	const subNavigations: any = inject("subNavigations");
	const route = useRoute();
	const notify = useNotyf();
	const isLoading = ref(false);
	const router = useRouter();
	const menu = computed(() => {
		return (navigations?.value || []).filter((item: any) => {
			// Guard against null/undefined entries that may appear while the
			// navigation computed is still resolving (seen after the role-gated
			// menu filter pruned hidden entries).
			if (!item) return false;
			return item.name != "profile" && item.name != "logout" && item.name != "settings";
		});
	});
	const indexMenu = ref(0);
	const openMoreMenu = ref(true);

	/**
	 * Flyout du bas (avatar) en mode replié : rend Déconnexion / Paramètres /
	 * Profil accessibles quand le sidebar est en rail. Ouvre vers le HAUT
	 * (l'avatar est en bas), téléporté dans <body>, scrollable si besoin.
	 */
	const showProfileFlyout = ref(false);
	const avatarRef = ref<any>(null);
	const profileFlyoutStyle = ref<any>({});
	let profileCloseTimer: any = null;

	const openProfileFlyout = () => {
		if (!collapsed.value) return;
		clearTimeout(profileCloseTimer);
		const el = avatarRef.value;
		if (el && el.getBoundingClientRect) {
			const r = el.getBoundingClientRect();
			const margin = 10;
			const vh = window.innerHeight;
			profileFlyoutStyle.value = {
				position: "fixed",
				left: `${r.right + 8}px`,
				bottom: `${vh - r.bottom}px`,
				maxHeight: `${r.bottom - margin}px`,
			};
		}
		showProfileFlyout.value = true;
	};
	const keepProfileFlyout = () => clearTimeout(profileCloseTimer);
	const scheduleCloseProfileFlyout = () => {
		profileCloseTimer = setTimeout(() => (showProfileFlyout.value = false), 160);
	};

	/**
	 * Function
	 */
	const handleLogout = async () => {
		isLoading.value = true;
		authLogout()
			.then(() => {
				isLoading.value = false;
				router.push({ name: "auth-login" });
			})
			.catch(() => {
				isLoading.value = false;
				notify.error("Something went wrong");
			});
	};

	/**
	 * Component lifecycle
	 */
	onMounted(() => {
		// console.log('subNavigations.value: ', subNavigations.value, route.matched, userInfos.value, authStatus.value);
	});

	onBeforeMount(() => {
		// Menu is now computed reactively — no manual assignment needed
	});


return (_ctx: any,_cache: any) => {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_MenuLink = _resolveComponent("MenuLink")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_MoreMenuLink = _resolveComponent("MoreMenuLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'flex flex-col justify-between h-full bg-gradient-to-t to-[#2D313E] from-[#030F00] rounded-tr-[0px] transition-all duration-300',
			_unref(collapsed) ? 'px-2' : 'px-4',
		])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["pt-8 flex items-center", _unref(collapsed) ? 'justify-center' : 'justify-between'])
      }, [
        (!_unref(collapsed))
          ? (_openBlock(), _createBlock(_component_AppLogo, {
              key: 0,
              width: "w-40"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggle) && _unref(toggle)(...args))),
          title: _unref(collapsed) ? 'Déplier le menu' : 'Replier le menu',
          class: "p-2 text-gray-300 rounded-lg hover:bg-[#2D334A] hover:text-accent focus:outline-none"
        }, _hoisted_4, 8, _hoisted_2)
      ], 2),
      _createElementVNode("nav", {
        class: _normalizeClass([
					'flex flex-col space-y-1 overflow-y-auto custumScroll',
					_unref(collapsed) ? 'items-center' : '',
				]),
        style: {"height":"calc(100vh - 22rem)"},
        id: "mainMenu"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            item
              ? (_openBlock(), _createBlock(_component_MenuLink, {
                  key: 0,
                  name: item.name,
                  title: item.title,
                  routeName: item.route,
                  icon: item.icon,
                  collapsed: _unref(collapsed),
                  featureFlag: item.feature_flag ?? '',
                  userRoles: item.user_roles ?? [],
                  resources: item.allowed_resources ?? [],
                  permissions: item.allowed_permissions ?? [],
                  subMenu: item.elements ?? []
                }, null, 8, ["name", "title", "routeName", "icon", "collapsed", "featureFlag", "userRoles", "resources", "permissions", "subMenu"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        ref_key: "avatarRef",
        ref: avatarRef,
        onMouseenter: openProfileFlyout,
        onMouseleave: scheduleCloseProfileFlyout,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (!_unref(collapsed) && (openMoreMenu.value = !openMoreMenu.value))),
        class: _normalizeClass([
					'flex flex-row items-center cursor-pointer',
					_unref(collapsed) ? 'justify-center' : 'justify-between',
				])
      }, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (!_unref(collapsed))
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(authStatus) == "connected" ? (_unref(userInfos)?.personal_info?.name ?? _unref(userInfos)?.account?.email ?? '') : ""), 1))
            : _createCommentVNode("", true)
        ]),
        (!_unref(collapsed))
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              src: "/media/icons/arrow-down-icon.svg",
              css: "w-6 h-6",
              class: _normalizeClass({ 'rotate-180': openMoreMenu.value })
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
      ], 34),
      _createVNode(_Transition, { name: "list" }, {
        default: _withCtx(() => [
          (openMoreMenu.value && !_unref(collapsed))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigations), (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    item
                      ? (_openBlock(), _createBlock(_component_MoreMenuLink, {
                          key: 0,
                          name: item.name,
                          title: item.title,
                          featureFlag: item.feature_flag ?? '',
                          routeName: item.route,
                          icon: item.icon,
                          resources: item.allowed_resources ?? [],
                          permissions: item.allowed_permissions ?? [],
                          userRoles: item.user_roles ?? []
                        }, null, 8, ["name", "title", "featureFlag", "routeName", "icon", "resources", "permissions", "userRoles"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _withDirectives(_createElementVNode("div", {
          style: _normalizeStyle(profileFlyoutStyle.value),
          onMouseenter: keepProfileFlyout,
          onMouseleave: scheduleCloseProfileFlyout,
          class: "z-[100] flex flex-col min-w-[220px] p-3 shadow-2xl rounded-xl bg-[#2D313E] ring-1 ring-black/40"
        }, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(authStatus) == "connected" ? (_unref(userInfos)?.personal_info?.name ?? _unref(userInfos)?.account?.email ?? '') : ""), 1),
          _createElementVNode("nav", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigations), (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: 'pf' + index
              }, [
                item
                  ? (_openBlock(), _createBlock(_component_MoreMenuLink, {
                      key: 0,
                      name: item.name,
                      title: item.title,
                      featureFlag: item.feature_flag ?? '',
                      routeName: item.route,
                      icon: item.icon,
                      resources: item.allowed_resources ?? [],
                      permissions: item.allowed_permissions ?? [],
                      userRoles: item.user_roles ?? []
                    }, null, 8, ["name", "title", "featureFlag", "routeName", "icon", "resources", "permissions", "userRoles"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ], 36), [
          [_vShow, showProfileFlyout.value]
        ])
      ]))
    ])
  ], 2))
}
}

})